<template>
  <div class="vhp-product-slide" v-if="items && items.length > 0">
    <div class="product-card">
      <div class="product-wrap">
        <div class="content-wrap">
          <div>
            <div class="vhp-text small red bold">
              {{ items[slide].brand }}
            </div>
            <div class="vhp-text bold" style="font-size: 1.8rem">
              {{ items[slide].title }}
            </div>
            <div class="vhp-text medium mt-4">
              {{ items[slide].subtitle }}<br />
            </div>
          </div>

          <div>
            <button
              class="vhp-button outline"
              @click="onClickItem(items[slide], false)"
            >
              {{ $t("상세보기") }}
            </button>
          </div>
        </div>

        <div v-if="showGlb && items[slide].glb" class="viewer-wrap">
          <viewer :url="items[slide].glb" />
        </div>
        <div v-else class="image-card-wrap">
          <img
            v-if="items[slide].thumbnail"
            class="image-card"
            :src="items[slide].thumbnail"
            cover
          />
          <img
            v-else
            class="image-card"
            :src="items[slide].images[0] || ''"
            cover
          />
        </div>
      </div>

      <div class="product-wrap">
        <div class="content-wrap">
          <div>
            <div class="vhp-text small red bold">
              {{ items[(slide + 1) % items.length].brand }}
            </div>
            <div class="vhp-text bold" style="font-size: 1.8rem">
              {{ items[(slide + 1) % items.length].title }}
            </div>
            <div class="vhp-text medium mt-4">
              {{ items[(slide + 1) % items.length].subtitle }}<br />
            </div>
          </div>

          <div>
            <button
              class="vhp-button outline"
              @click="onClickItem(items[(slide + 1) % items.length], false)"
            >
              {{ $t("상세보기") }}
            </button>
          </div>
        </div>

        <div
          v-if="showGlb && items[(slide + 1) % items.length].glb"
          class="viewer-wrap"
        >
          <viewer :url="items[(slide + 1) % items.length].glb" />
        </div>
        <div v-else class="image-card-wrap">
          <img
            v-if="items[(slide + 1) % items.length].thumbnail"
            class="image-card"
            :src="items[(slide + 1) % items.length].thumbnail"
            cover
          />
          <img
            v-else
            class="image-card"
            :src="items[(slide + 1) % items.length].images[0] || ''"
            cover
          />
        </div>
      </div>

      <div class="slide-button-wrap">
        <div class="slide-button prev" @click="prev()">
          <span />
          <span />
        </div>

        <div class="slide-button next" @click="next()">
          <span />
          <span />
        </div>

        <div class="slide-sequence">
          <span
            v-for="n in items.length"
            :key="'sequence-' + n"
            :class="
              n - 1 <= slide + (maxCount - 1) && n - 1 >= slide ? 'active' : ''
            "
          >
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import viewer from "@/components/etc/vhp3dViewer.vue";
export default {
  components: {
    viewer,
  },
  props: {
    items: {
      type: Array,
      default: () => {
        return [];
      },
    },
    baseUrl: {
      type: String,
      default: "/",
    },
    listUrl: {
      type: String,
      default: "/",
    },
    show3d: {
      type: Boolean,
      default: false,
    },
  },
  computed: {},
  data() {
    return {
      showGlb: false,
      slide: 0,
      maxCount: 1,
    };
  },
  mounted() {
    if (this.show3d) {
      this.showGlb = true;
    }
  },
  watch: {},
  methods: {
    prev() {
      this.slide =
        this.slide > 0 ? this.slide - 1 : this.items.length - this.maxCount;
    },
    next() {
      this.slide =
        this.slide < this.items.length - this.maxCount ? this.slide + 1 : 0;
    },
    onClickItem(item, inquiry) {
      if (inquiry) {
        this.$router.push(
          this.baseUrl +
            "?id=" +
            item.id +
            "&list=" +
            this.listUrl +
            "&inquiry=true"
        );
      } else {
        this.$router.push(
          this.baseUrl + "?id=" + item.id + "&list=" + this.listUrl
        );
      }
    },
  },
};
</script>

<style lang="scss" src="./vhpProductSlide.scss"></style>
